import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionStartDialogComponent } from './section-start-dialog/section-start-dialog.component';
import { SectionFinishDialogComponent } from './section-finish-dialog/section-finish-dialog.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { OrganizationAdminAreaGuideComponent } from './tour/oa-admin-area/admin-area-guide.component';
import { GeneralInformationComponent } from './tour/oa-admin-area/general-information/general-information.component';
import { MyGroupsComponent } from './tour/oa-admin-area/my-groups/my-groups.component';
import { MyServicesComponent } from './tour/oa-admin-area/my-services/my-services.component';
import { MyEmployeesComponent } from './tour/oa-admin-area/my-employees/my-employees.component';

@NgModule({
  imports: [
    CommonModule,
    MarkantElementsModule,
    ModalBridgeComponent,
    TranslocoModule,
    RouterLink,
    SectionFinishDialogComponent,
    MyGroupsComponent,
    MyServicesComponent,
    OrganizationAdminAreaGuideComponent,
    GeneralInformationComponent,
    MyEmployeesComponent,
    SectionStartDialogComponent,
  ],
  exports: [
    OrganizationAdminAreaGuideComponent,
    SectionFinishDialogComponent,
    GeneralInformationComponent,
    SectionStartDialogComponent,
  ],
})
export class SharedGuidedTourModule {}
